'use client';
import React, { useState, useRef, useEffect } from 'react';
import s from '../../Feature.module.scss';
import ContentfulImage from '../../../../../components/ContentfulImage';
import { RenderImageContext, RenderImageProps, ColumnsPhotoAlbum } from 'react-photo-album';
import RichText from '../../../../../components/RichText';
import "react-photo-album/columns.css";
import { CaseStudyFeature } from '../../../../../constants/types';
import { removeInvalidImages, mapIconData } from '../../../../../utils/iconHelpers';

interface ViewType4Props {
  item: CaseStudyFeature;
}

function renderNextImage(porp: RenderImageProps, image: RenderImageContext) {
  const  { alt = "", title } = porp;
  const { photo, width, height } = image

  const fluid = {src: photo.src, aspectRatio: Number(title) ,sizes:'(max-width: 1000px) 100vw, 1000px', width, height}
  return (
    <ContentfulImage
    alt={alt}
    fluid={fluid}/>
  );
}

const ViewType4: React.FC<ViewType4Props> = ({ 
  item
}) => {
  const { description, imageSliders, hideTitle, title, backgroundColor } = item;

  const [clickStartX, setClickStartX] = useState<number>();
  const [scrollStartX, setScrollStartX] = useState<number>();
  const scrollWrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const scrollWrapper = scrollWrapperRef.current;
    if (!scrollWrapper) return;

    const handleDragStart = (e: MouseEvent) => {
      e.preventDefault();
      setClickStartX(e.screenX);
      setScrollStartX(scrollWrapper.scrollLeft);
    };

    const handleDragMove = (e: MouseEvent) => {
      e.preventDefault();
      if (clickStartX !== undefined && scrollStartX !== undefined) {
        const touchDelta = clickStartX - e.screenX;
        scrollWrapper.scrollLeft = scrollStartX + touchDelta;
      }
    };

    const handleDragEnd = () => {
      if (clickStartX !== undefined) {
        setClickStartX(undefined);
        setScrollStartX(undefined);
      }
    };

    if (scrollWrapper.ontouchstart === undefined) {
      scrollWrapper.addEventListener('mousedown', handleDragStart);
      scrollWrapper.addEventListener('mousemove', handleDragMove);
      scrollWrapper.addEventListener('mouseup', handleDragEnd);
      scrollWrapper.addEventListener('mouseleave', handleDragEnd);
    }

    return () => {
      scrollWrapper.removeEventListener('mousedown', handleDragStart);
      scrollWrapper.removeEventListener('mousemove', handleDragMove);
      scrollWrapper.removeEventListener('mouseup', handleDragEnd);
      scrollWrapper.removeEventListener('mouseleave', handleDragEnd);
    };
  }, [clickStartX, scrollStartX]);
  

    const photos = removeInvalidImages(imageSliders || [])
      .map((icon) => {
        const mapped = mapIconData(icon);
        return {
            ...mapped,
            src: mapped.url,
        };
      });
      
  return (
    <div className={s.root}>
      <div
        className={[s.viewType4, s.container].join(' ')}
        style={{ background: backgroundColor || '' }}
        data-testid="viewtype4-container"
      >
        <div className={s.subContainer}>
          <div className={s.textBlock}>
            {!hideTitle && (
              <h2 className={s.title} data-testid="viewtype4-title">
                {title}
              </h2>
            )}
            <div className={s.content} data-testid="viewtype4-content">
              {description && <RichText data={description}/>}
            </div>
          </div>
        </div>
      </div>
      <div className={s.scrollContainer}>
        <div className={s.scrollImageSection}>
            <ColumnsPhotoAlbum columns={3} photos={photos} render={{ image: renderNextImage }}>
            </ColumnsPhotoAlbum>
        </div>
      </div>
    </div>
  );
};

export default ViewType4;
